/**
 * @module app.bdc.list.formWebTillInfoCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function FormWebTillInfoCtrl($scope, $uibModalInstance, webTillPackage) {
        var self = {};
        self.webTillPackage = webTillPackage;

        self.close = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    FormWebTillInfoCtrl.$inject = ['$scope', '$uibModalInstance', 'webTillPackage', 'order'];

    angular
        .module('app.bdc.list.formWebTillInfoCtrl', ['ui.bootstrap.modal'])
        .controller('FormWebTillInfoCtrl', FormWebTillInfoCtrl);
});
